import styled from '@emotion/styled';

export type CaretProps = {
    size?: number;
    direction: 'UP' | 'DOWN' | 'LEFT' | 'RIGHT';
};

export const Caret = styled.span<CaretProps>(props => ({
    display: 'inline-block',
    width: 0,
    height: 0,
    verticalAlign: props.direction == 'UP' ? 'text-top' : (props.direction == 'DOWN' ? 'middle' : 'text-bottom'),
    borderTop: `${props.size || 4}px dashed ${props.direction == 'DOWN' ? '' : ' transparent'}`,
    borderLeft: `${props.size || 4}px dashed ${props.direction == 'RIGHT' ? '' : ' transparent'}`,
    borderRight: `${props.size || 4}px dashed ${props.direction == 'LEFT' ? '' : ' transparent'}`,
    borderBottom: `${props.size || 4}px dashed ${props.direction == 'UP' ? '' : ' transparent'}`,
    margin: '4px',
}));
